import { CommonFieldType } from './utils';

export type NotificationBadge = {
  readCount: number;
  totalCount: number;
  unReadCount: number;
  updatedAt: number;
};

export type NotificationType = CommonFieldType & {
  title: string;
  content: string;
  isRead: boolean;
  receiverUserId: string;
  type: string;
  category?: NotificationCategory;
  link?: string;
};

export enum NotificationCategory {
  BUY = 'BUY',
  SELL = 'SELL',
  TOPUP_CREDIT = 'TOPUP_CREDIT',
  WITHDRAW_CREDIT = 'WITHDRAW_CREDIT',
  REDEEM = 'REDEEM',
  CREDIT_LOAN = 'CREDIT_LOAN',
  PAY_CREDIT_LOAN = 'PAY_CREDIT_LOAN',
}
